import firebase from 'firebase/app';
import 'firebase/firestore';

const config = {
  apiKey: "AIzaSyAu6oqQ9hVsw_hgsSqPBwpVW9ZSuYyij90",
  authDomain: "adenzo-404af.firebaseapp.com",
  databaseURL: "https://adenzo-404af.firebaseio.com",
  projectId: "adenzo-404af",
  storageBucket: "adenzo-404af.appspot.com",
  messagingSenderId: "629450577383"
};

firebase.initializeApp(config);

export default firebase;
